import { useSplitText } from "@/hooks/useSplitText";
import { forwardRef } from "react";

const SplitHeading = forwardRef(function SplitHeading(
  { children, as: Component = "h2", className = "", type = "words", y = 60, rotateX = -30, duration = 0.9, stagger = 0.04, start = "top 85%" },
  forwardedRef
) {
  const splitRef = useSplitText({ type, y, rotateX, duration, stagger, start });

  const setRefs = (node) => {
    splitRef.current = node;
    if (typeof forwardedRef === "function") {
      forwardedRef(node);
    } else if (forwardedRef) {
      forwardedRef.current = node;
    }
  };

  return (
    <Component ref={setRefs} className={className}>
      {children}
    </Component>
  );
});

export default SplitHeading;
